import mKTDownloadHandler from "@NA/Handlers/MKTDownloadHandler";
import WarningRedIcon from "@NA/Icons/WarningRedIcon";
import {
    ProductsMktCollectionModel,
    downloadMKTFileName,
    removeAllMktFile,
    uploadMktFile,
} from "@NA/Services/ADIMktUploadService";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonProps } from "@insite/mobius/Button";
import FileUpload from "@insite/mobius/FileUpload";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ChangeEvent, useEffect, useState } from "react";
import { connect, ResolveThunks, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { css } from "styled-components";
import * as xlsx from "xlsx";

interface OwnProps extends WidgetProps {
    pagination?: any;
}
const mapStateToProps = (state: CustomApplicationState) => {
    const isAuthenticated = state.context.session.isAuthenticated;
    return {
        isAuthenticated,
    };
};

interface RowVal {
    ADIPartNo: string;
    StartDate: string;
    EndDate: string;
    SaleTypeIndicator: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface ADIMKTUploadStyles {
    wrapper?: InjectableCss;
    uploadWrapper?: InjectableCss;
    buttonWrapper?: InjectableCss;
    removeAllButton?: InjectableCss;
    removeAllModal?: ModalPresentationProps;
    removeAllText?: InjectableCss;
    removeButtonContainer?: InjectableCss;
    loader?: InjectableCss;
    formField?: InjectableCss;
    formButton?: InjectableCss;
    formText?: TypographyProps;
    invalidFileExtension?: TypographyProps;
    buttonDownload?: ButtonProps;
    closeModalButton?: ButtonProps;
    removeAllModalButton?: ButtonProps;
    buttonUpload?: ButtonProps;
    uploadText?: InjectableCss;
    warning?: InjectableCss;
    blueCircle?: InjectableCss;
    loaderWapper?: InjectableCss;
    operationFailedLoaderWapper?: InjectableCss;
    errorsWrapper?: InjectableCss;
}

export const adiMktUploadStyles: ADIMKTUploadStyles = {
    wrapper: {
        css: css`
            margin: 0;
            padding-left: 20px !important;
            padding-right: 20px !important;
            border: 1px solid ${ADIColors.gray10};
            padding: 16px 20px;
            position: relative;
            &.mainContainer {
                /* opacity: 0.7; */
            }
        `,
    },
    errorsWrapper: {
        css: css`
            margin-left: 0.937rem;
            line-height: 20px;
            margin-top: 11px;
        `,
    },
    loader: {
        css: css`
            margin: 0 auto;
            width: 100%;
        `,
    },
    loaderWapper: {
        css: css`
            position: absolute;
            background-color: ${ADIColors.white};
            width: 94%;
            height: 85%;
            z-index: 100;
        `,
    },
    operationFailedLoaderWapper: {
        css: css`
            position: absolute;
            background-color: ${ADIColors.white};
            width: 94%;
            height: 85%;
            z-index: 100;
            opacity:.85;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-direction:column;
        `,
    },
    blueCircle: {
        css: css`
            font-size: 14px;
            line-height: 20px;
            position: relative;
            height: 42px;
            width: 42px;
            border-radius: 50%;
            background-color: ${ADIColors.blue11};
            margin: 0 auto;
            &:after {
                content: "";
                position: absolute;
                display: block;
                left: 15px;
                top: 8px;
                width: 12px;
                height: 22px;
                border: solid ${ADIColors.white};
                border-width: 0 5px 5px 0;
                -webkit-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                transform: rotate(45deg);
            }
        `,
    },
    warning: {
        css: css`
            position: relative;
            justify-content: center;
            display: flex;
            margin-top: 10px;
        `,
    },
    uploadText: {
        css: css`
            text-align: center;
        `,
    },
    uploadWrapper: {
        css: css`
            min-height: 80px;
            display: flex;
            justify-items: center;
            gap: 5px;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            position: relative;
        `,
    },
    removeAllButton: {
        css: css`
            outline-width: 0px !important;
            font-size: 14px;
            margin-right: 14px;
            font-family: "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
        `,
    },
    removeAllModal: {
        cssOverrides: {
            modalBody: css`
                max-width: 636px !important;
            `,
            modalContent: css`
                padding-top: 0;
                padding-bottom: 60px;
            `,
            modalTitle: css`
                border-bottom: 0;
            `,
        },
    },
    removeAllText: {
        css: css`
            font-size: 18px;
            line-height: 28px;
            font-weight: bold;
            margin-bottom: 0;
            color: ${ADIColors.darkBlue1};
            text-align: center;
        `,
    },
    removeButtonContainer: {
        css: css`
            margin-top: 48px;
            display: flex;
            justify-content: center;
        `,
    },
    formButton: {
        css: css`
            height: 30px;
            min-height: auto !important;
            line-height: 20px;
            padding: 10px 27px;
            margin: 0;
            font-size: 14px;
            font-weight: bold;
            background-color: ${ADIColors.lightRed2} !important;
            color: ${ADIColors.white};
            text-align: center;
            float: left;
            border-radius: 0px;
            border: none;
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover {
                opacity: 0.9;
            }
        `,
    },
    formText: {
        css: css`
            padding-top: 10px;
            margin-left: 10px;
        `,
    },
    invalidFileExtension: {
        css: css`
            color: ${ADIColors.red2};
            font-size: 14px;
            margin-left: 10px;
            line-height: 20px;
        `,
    },
    buttonDownload: {
        css: css`
            min-height: 26px;
            min-width: 112px;
            padding: 0px 16px;
            margin: 0;
            line-height: 17px;
            font-size: 14px;
            font-weight: bold;
            background-color: transparent !important;
            color: ${ADIColors.blue10} !important;
            text-align: center;
            border-radius: 0px;
            border: 1px solid ${ADIColors.gray26};
        `,
    },
    closeModalButton: {
        css: css`
            border: 1px solid ${ADIColors.gray26};
            font-size: 14px;
            line-height: 17px;
            color: ${ADIColors.blue10};
            width: auto;
            min-width: 112px;
            min-height: 26px;
            height: auto;
            border-radius: 0;
            font-weight: bold;
            margin: 0 7px;
            &:hover {
                color: ${ADIColors.blue10} !important;
                border: 1px solid ${ADIColors.gray26} !important;
            }
        `,
    },
    removeAllModalButton: {
        css: css`
            background-color: ${ADIColors.lightRed2};
            height: inherit;
            min-height: 26px;
            border-radius: 0;
            box-shadow: none;
            min-width: 112px;
            font-size: 14px;
            line-height: 17px;
            font-weight: bold;
            text-transform: initial;
            margin: 0 7px;
            padding: 0 !important;
            border: none;
            font-family: "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
            > span {
                color: ${ADIColors.white};
            }
        `,
    },
    buttonUpload: {
        css: css`
            min-height: 26px;
            line-height: 17px;
            padding: 0px 27px;
            margin: 0;
            font-size: 14px;
            font-weight: bold;
            background-color: ${ADIColors.lightRed2} !important;
            color: ${ADIColors.white};
            text-align: center;
            border-radius: 0px;
            border: none;
            margin-left: 14px;
            &:disabled {
                background-color: ${ADIColors.gray11} !important;
                color: ${ADIColors.gray23};
                > span {
                    color: ${ADIColors.gray24} !important;
                }
                cursor: default;
            }
            &:hover {
                opacity: 0.9;
                background-color: ${ADIColors.lightRed2};
                border: none;
            }
        `,
    },
};

const styles = adiMktUploadStyles;
const isBlankRows = false;
let isDateMismatch = false;
let isDataMissing = false;
let isDateError = false;
let isDuplicateProduct = false;

const MKTUploadZone = () => {
    const [filename, setFilename] = useState("No File selected.");
    const [file, setFile] = useState<File | null>(null);
    const [errorMessage, setErrorMessage] = useState(false);
    const [isValidFile, setIsValidFile] = useState(false);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [removeStatus, setRemoveStatus] = React.useState(false);
    const [removeCompleted, setRemoveCompleted] = React.useState(false);
    const [operationFailed, setOperationFailed] = React.useState(false);
    const [fileEmpty, setFileEmpty] = React.useState(false);
    const [blankRows, setBlankRows] = React.useState(false);
    const [firstRowHeading, setFirstRowHeading] = React.useState(false);
    const [browsePanel, setBrowsePanel] = useState(false);
    const dispatch: any = useDispatch();
    // const [dataMissing, setDataMissing] = useState<boolean>(false);
    const [displayMsg, setDisplayMsg] = useState<string>("");
    const [isStartDateValid, setIsStartDateValid] = useState<boolean>(false);
    const [isEndDateValid, setIsEndDateValid] = useState<boolean>(false);
    const [dateMismatch, setDateMismatch] = useState<boolean>(false);
    const [dateFormatError, setDateFormatError] = useState<boolean>(false);
    const [duplicateProductError, setDuplicateProductError] = useState<boolean>(false);
    const [duplicateSaleTypeError, setDuplicateSaleTypeError] = useState<boolean>(false);
    const [xlMsgCollection, setXlMsgCollection] = useState<string[]>([]);
    const [overlap, setOverlap] = useState<boolean>(false);
    const [mktCommonError, setMktCommonError] = useState<boolean>(false);

    const [errorMsgCount, setErrorMsgCount] = useState(0);
    const [mktRowErrors, setMktRowErrors] = useState<string[]>([]);
    const [mktErrorMsgs, setMktErrorMsgs] = useState(new Array(10).fill(""));
    // const [duplicateErrorMsg, setDuplicateErrorMsg] = useState([]);
    const [duplicateErrorMsg, setDuplicateErrorMsg] = useState<number[]>([]);

    // const [fileUploadCompleted, setFileUploadCompleted] = useState<boolean>(true);
    const [fileUploadCompleted, setFileUploadCompleted] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const enableRowError = (rowNo: any, bindmsg = "") => {
        setIsLoading(false);
        if (rowNo <= 10) {
            setErrorMsgCount(errorMsgCount + 1);
            setMktRowErrors(prevErrors => {
                const updatedErrors = [...prevErrors];
                if (updatedErrors) {
                    updatedErrors[rowNo] = `[${rowNo}] ${bindmsg || ""}`;
                }
                return updatedErrors;
            });
            setMktErrorMsgs(prevMsgs => {
                const updatedMsgs = [...prevMsgs];
                updatedMsgs[rowNo] = bindmsg;
                return updatedMsgs;
            });
        }
        if (rowNo > 10 && errorMsgCount <= 10) {
            const errorIndex = duplicateErrorMsg.indexOf(rowNo);
            if (errorIndex === -1) {
                const firstEmptyIndex = mktRowErrors.findIndex(msg => msg === undefined);
                if (firstEmptyIndex !== -1) {
                    setErrorMsgCount(errorMsgCount + 1);
                    setMktRowErrors((prevErrors: any) => {
                        const updatedErrors = [...prevErrors];
                        updatedErrors[firstEmptyIndex] = `[${rowNo}] ${bindmsg || ""}`;
                        return updatedErrors;
                    });
                    setMktErrorMsgs(prevMsgs => {
                        const updatedMsgs = [...prevMsgs];
                        updatedMsgs[firstEmptyIndex] = bindmsg;
                        return updatedMsgs;
                    });
                    setDuplicateErrorMsg([...duplicateErrorMsg, rowNo]);
                } else {
                    setMktRowErrors((prevErrors: any) => [...prevErrors, `[${rowNo}] ${bindmsg || ""}`]);
                }
            }
        }
    };
    const uploadMkt = (event: ChangeEvent<any>) => {
        setFilename("");
        setFile(null);
        setMktRowErrors([]);
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            setFilename(file.name);
            setFile(file);
            setMktRowErrors([]);

            // Code after adding errormessage for file format
            const fileExt = getFileExtention(file.name);
            const isValid = fileExt === "xls" || fileExt === "xlsx";
            setIsValidFile(isValid);

            if (fileExt === "xls" || fileExt === "xlsx") {
                setFilename(file.name);
                setErrorMessage(false);
                setBlankRows(false);
                setMktCommonError(false);
            } else {
                setFilename(file.name);
                setErrorMessage(true);
                setBlankRows(false);
                setMktCommonError(false);
            }
        }
    };

    const getFileExtention = (fileName: string): string => {
        const splittedFileName: string[] = fileName.split(".");
        return splittedFileName.length > 0 ? splittedFileName[splittedFileName.length - 1].toLowerCase() : "";
    };

    const MessageBind = (
        rowNo: string | number,
        dataMissing = false,
        dateFormatError = false,
        dateMismatch = false,
        duplicateProductError = false,
        duplicateSaleTypeError = false,
    ) => {
        let messagereason = "";

        if (dataMissing) {
            messagereason = "Data Missing";
        }
        if (dateFormatError) {
            messagereason = "Invalid Date Format";
        }
        if (dateMismatch) {
            messagereason = "Start date is greater than the end date";
        }
        if (duplicateProductError) {
            messagereason = "Duplicate Product with date overlap";
        }
        // if (duplicatesaletypeError) {
        //    messagereason = "One SaleType must be NP"
        // }

        return `[${rowNo}] ${messagereason}`;
    };

    const isValidDate = (date: any, type: string) => {
        const dateRegex = /^(0[1-9]|1[0-2])[-\/](0[1-9]|1\d|2\d|3[01])[-\/](19|20)\d{2}$/;
        if (type === "SD") {
            setIsStartDateValid(dateRegex.test(date));
        } else {
            setIsEndDateValid(dateRegex.test(date));
        }
        return dateRegex.test(date);
    };

    const displayBlankRowsMessage = () => {
        setBlankRows(true);
        setIsLoading(false);
    };
    const handleValidatedates = (rowNo: number, rowVal: any, productsMktCollection: any) => {
        setIsStartDateValid(isValidDate(rowVal.StartDate, "SD"));
        setIsEndDateValid(isValidDate(rowVal.EndDate, "ED"));

        if (isValidDate(rowVal.StartDate, "SD") && isValidDate(rowVal.EndDate, "ED")) {
            const sdate = new Date(rowVal.StartDate.toString());
            const edate = new Date(rowVal.EndDate.toString());

            if (edate < sdate) {
                setDateMismatch(true);
                isDateMismatch = true;
                setIsLoading(false);
                setDisplayMsg(MessageBind(rowNo + 1, false, false, isDateMismatch));
                setXlMsgCollection([...xlMsgCollection, "Start date is greater than the end date"]);
                enableRowError(xlMsgCollection.length, "Start date is greater than the end datey");
            } else {
                const duplicate = productsMktCollection.filter(
                    (f: any) => f?.ADIPartNo?.trim() === rowVal?.ADIPartNo?.trim(),
                );

                if (duplicate.length >= 2) {
                    for (let i = 0; i < duplicate.length; i++) {
                        for (let j = i + 1; j < duplicate.length; j++) {
                            if (
                                duplicate[i].StartDate <= duplicate[j].EndDate &&
                                duplicate[j].StartDate <= duplicate[i].EndDate &&
                                (!(
                                    duplicate[i].SaleTypeIndicator.toUpperCase() === "NP" ||
                                    duplicate[j].SaleTypeIndicator.toUpperCase() === "NP"
                                ) ||
                                    duplicate[i].SaleTypeIndicator.toUpperCase() ===
                                    duplicate[j].SaleTypeIndicator.toUpperCase())
                            ) {
                                setDuplicateProductError(true);
                                if (duplicateProductError && overlap) {
                                    setIsLoading(false);
                                    setDisplayMsg(
                                        MessageBind(duplicate[j].CurrentIndex + 1, false, false, false, true),
                                    );
                                    setXlMsgCollection([...xlMsgCollection, displayMsg]);
                                    enableRowError(duplicate[j].CurrentIndex + 1, displayMsg);
                                }

                                setOverlap(true);
                            } else {
                                setOverlap(false);
                            }
                        }

                        if (duplicateProductError && overlap) {
                            setIsLoading(false);
                            setDisplayMsg(MessageBind(duplicate[i].CurrentIndex + 1, false, false, false, true));
                            setXlMsgCollection([...xlMsgCollection, displayMsg]);
                            enableRowError(duplicate[i].CurrentIndex + 1, displayMsg);
                        }
                    }
                }
            }
        } else {
            setDateFormatError(true);
            isDateError = true;
            setIsLoading(false);
            setDisplayMsg(MessageBind(rowNo + 1, false, true));
            setXlMsgCollection([...xlMsgCollection, displayMsg]);
            enableRowError(rowNo + 1, "Invalid Date Format");
        }
    };
    const handleDataMissingValidation = (rowNo: number) => {
        // setDataMissing(true);
        isDataMissing = true;
        setIsLoading(false);
        setDisplayMsg(MessageBind(rowNo + 1, isDataMissing));
        setXlMsgCollection([...xlMsgCollection, "Data Missing"]);
        enableRowError(rowNo + 1, "Data Missing");
    };
    const handleUpload = () => {
        if (!file) {
            return;
        }
        const reader = new FileReader();
        setIsLoading(true);
        const fileExt = getFileExtention(file.name);
        if (fileExt) {
            setIsValidFile(false);
        }
        // setFile(null);
        // setFilename('');
        reader.onload = (evt: any) => {
            if (!evt) { return; }
            const bstr = evt.target.result;

            try {
                if (fileExt === "xls" || fileExt === "xlsx") {
                    const wb = xlsx.read(bstr, { type: "binary" });
                    if (wb) {
                        wb.SheetNames.forEach(sheetName => {
                            const opts = { header: 1 };

                            const sheet = wb.Sheets[sheetName];
                            const cell = sheet["!ref"];
                            // if (!cell?.contains("A1")) {
                            if (!cell?.includes("A1")) {
                                setBlankRows(true);
                            }

                            if (cell?.includes("A1")) {
                                let roa = xlsx.utils.sheet_to_json(wb.Sheets[sheetName], opts);

                                if (firstRowHeading) {
                                    roa = roa.slice(1, roa.length);
                                }

                                let productsMktCollection = roa.map((r: any, i) => {
                                    const obj = {
                                        ADIPartNo: r[0],
                                        CurrentIndex: i,
                                        EndDate: r[2],
                                        SaleTypeIndicator: r[3],
                                        StartDate: r[1],
                                    };
                                    return obj;
                                });

                                let isEmptyRow = false;
                                let duplicateRow = false;

                                if (productsMktCollection.length > 0) {
                                    if (firstRowHeading) {
                                        productsMktCollection = productsMktCollection.slice(
                                            0,
                                            productsMktCollection.length,
                                        );
                                    }

                                    productsMktCollection.forEach((rowVal: any, rowNo) => {
                                        const duplicates = productsMktCollection.filter(
                                            (f: any) => f?.ADIPartNo?.trim() === rowVal?.ADIPartNo?.trim(),
                                        );

                                        if (
                                            !rowVal?.ADIPartNo ||
                                            !rowVal?.EndDate ||
                                            !rowVal?.SaleTypeIndicator ||
                                            !rowVal?.StartDate
                                        )
                                            isEmptyRow = true;
                                        if (duplicates.length >= 2) duplicateRow = true;

                                        if (isEmptyRow || duplicateRow) {
                                            if (duplicates.length >= 2) {
                                                for (const _ of duplicates) {
                                                    setIsLoading(false);
                                                    setDisplayMsg(
                                                        MessageBind(rowNo + 1, false, false, false, true),
                                                    );
                                                    setXlMsgCollection([...xlMsgCollection, "Duplicate Product with date overlap"]);
                                                    enableRowError(rowNo + 1, "Duplicate Product with date overlap");
                                                }
                                            }

                                            if (isEmptyRow) {
                                                displayUploadError();
                                                setMktRowErrors([]);
                                            } else {
                                                setOperationFailed(false)
                                            }
                                        }
                                        if (
                                            roa.length === rowNo + 1 &&
                                            (isDataMissing ||
                                                dateFormatError ||
                                                isDateError ||
                                                isDateMismatch ||
                                                duplicateProductError ||
                                                duplicateSaleTypeError)
                                        ) {
                                            console.log("1");
                                            displaymktCommonError();
                                        }


                                        if (
                                            !rowVal.ADIPartNo ||
                                            !rowVal.StartDate ||
                                            !rowVal.EndDate ||
                                            !rowVal.SaleTypeIndicator
                                        ) {
                                            handleDataMissingValidation(rowNo);
                                        }
                                        if (rowVal.StartDate || rowVal.EndDate) {
                                            handleValidatedates(rowNo, rowVal, productsMktCollection);
                                            //   displaymktCommonError()
                                        }

                                        if (duplicates.length >= 2) {
                                            isDuplicateProduct = true;
                                            displaymktCommonError()
                                        }


                                    });

                                }

                                if (
                                    productsMktCollection.length > 0 &&
                                    !isDataMissing &&
                                    !dateFormatError &&
                                    !isDateError &&
                                    !isDateMismatch &&
                                    !duplicateProductError &&
                                    !isDuplicateProduct &&
                                    !duplicateSaleTypeError
                                ) {
                                    uploadMktFile(productsMktCollection as ProductsMktCollectionModel[]).then(
                                        result => {
                                            uploadMktFileCompleted(result);
                                        },
                                    );
                                    // uploadProductMkt();
                                }
                            } else if (isBlankRows) {
                                displayBlankRowsMessage();
                                displaymktCommonError();
                            } else {
                                displaymktCommonError();
                            }
                        });
                    }
                } else {
                    setIsValidFile(false);
                    displaymktCommonError();
                }
            } catch (error) {
                setIsLoading(false);
                return null;
            }
        };

        reader.readAsBinaryString(file);
    };

    const uploadMktFileCompleted = (result: any) => {
        const d = result;
        if (d) {
            displayMktUploadComplete();
            setOperationFailed(false)
        } else {
            displayUploadError();
        }
    };

    const displayMktUploadComplete = () => {
        setFilename("No File selected");
        setFileUploadCompleted(true);
        setTimeout(() => {
            setFileUploadCompleted(false);
        }, 2000);
        setIsLoading(false);
        setIsValidFile(false);

    };

    const displayUploadError = () => {
        setOperationFailed(true);
    };

    const removeAllMktCompleted = (result: any) => {
        const d = result;
        setRemoveCompleted(true);
        setBrowsePanel(true);
        setFilename("No File selected");
        setTimeout(() => {
            setRemoveCompleted(false);
            setBrowsePanel(false);
            setMktCommonError(false);
        }, 5000);
        setMktErrorMsgs([]);
        setMktRowErrors([]);
    };

    const removeAllMktFailed = (error: any) => {
        setTimeout(() => {
            setOperationFailed(false);
            setFileUploadCompleted(false)
        }, 5000);
    };

    const displaymktCommonError = () => {
        setMktCommonError(true);
        setIsLoading(false);
    };
    const removeAllProductsMkt = () => {
        removeAllMktFile(removeStatus).then(
            result => removeAllMktCompleted(result),
            error => removeAllMktFailed(error),
        );
    };

    const removeAllFiles = () => {
        setRemoveStatus(false);
        setModalIsOpen(false);
        removeAllProductsMkt();
        setFilename("No File selected.");
        setIsValidFile(false);
        setFile(null);
        setFilename('')
    };

    const handleClick = async (fileName: any) => {
        const uri = `/api/v1/export/GetFile?file=${fileName}`;
        try {
            const response = await fetch(uri);
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) { /* empty */ }
    };

    const handleDownload = () => {
        downloadMKTFileName()
            .then(result => {
                const fileName: any = result.result;
                if (fileName?.toString() === "") {
                    displayMktDownloadError();
                } else {
                    dispatch(mKTDownloadHandler(fileName));
                }
            })
            .catch(() => {
                return null;
            });
    };

    const displayMktDownloadError = () => {
        setFileEmpty(true);
        setTimeout(() => {
            setFileEmpty(false);
        }, 5000);
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const removeAllHandler = () => {
        setModalIsOpen(true);
        setFilename('')
        setFile(null)
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setOperationFailed(false)
        }, 3000);
        return () => clearInterval(timer)
    }, [operationFailed])

    return (
        <>
            <StyledWrapper className={browsePanel ? "mainContainer" : ""} {...styles.wrapper}>
                {isLoading && !mktRowErrors.length && (
                    <StyledWrapper {...styles.loaderWapper}>
                        <LoadingSpinner {...styles.loader} />
                        <StyledWrapper {...styles.uploadText}>Upload Processing...</StyledWrapper>
                    </StyledWrapper>
                )}

                {browsePanel && removeCompleted && (
                    <StyledWrapper {...styles.loaderWapper}>
                        <StyledWrapper>
                            <StyledWrapper {...styles.blueCircle}></StyledWrapper>
                            <StyledWrapper {...styles.uploadText}>Remove all complete!</StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                )}

                {fileEmpty && (
                    <StyledWrapper {...styles.loaderWapper}>
                        <StyledWrapper>
                            <StyledWrapper {...styles.warning}>
                                <Icon src={WarningRedIcon} size={30} color={ADIColors.red1} />
                            </StyledWrapper>
                            <StyledWrapper {...styles.uploadText}> File is empty. </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                )}

                <StyledWrapper {...styles.uploadWrapper}>
                    <FileUpload
                        buttonText="Browse"
                        buttonProps={{ ...styles.formButton }}
                        onChange={uploadMkt}
                        cssOverrides={{
                            formField: css`
                                display: none;
                            `,
                        }}
                    />
                    <StyledWrapper>
                        <Typography {...styles.formText}>{filename}</Typography>
                        {/* invalidFileExtension */}
                        {errorMessage && (
                            <Typography {...styles.invalidFileExtension}>
                                {translate("File Not in Required Format.")}
                            </Typography>
                        )}
                        {blankRows && (
                            <Typography {...styles.invalidFileExtension}>
                                {translate("File has blank rows.")}
                            </Typography>
                        )}

                        {mktCommonError && (
                            <Typography as="p" {...styles.invalidFileExtension}>
                                {translate(
                                    "There are errors in the file. (For example file format, duplicate products, incorrect start and end dates etc.)",
                                )}
                            </Typography>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.buttonWrapper}>
                    <Link {...styles.removeAllButton} onClick={removeAllHandler}>
                        {translate("Remove All")}
                    </Link>
                    <Modal {...styles.removeAllModal} isOpen={modalIsOpen} handleClose={modalCloseHandler}>
                        <StyledWrapper {...styles.removeAllText}>
                            Are you sure you want to remove all records from the database?
                        </StyledWrapper>
                        <StyledWrapper {...styles.removeButtonContainer}>
                            <Button variant="secondary" onClick={modalCloseHandler} {...styles.closeModalButton}>
                                {translate("CANCEL")}
                            </Button>
                            <Button variant="secondary" onClick={removeAllFiles} {...styles.removeAllModalButton}>
                                {translate("Remove All")}
                            </Button>
                        </StyledWrapper>
                    </Modal>
                    {operationFailed && (
                        <Modal {...styles.removeAllModal} isOpen={operationFailed} handleClose={() => setOperationFailed(false)}>
                            <StyledWrapper>
                                <Icon src={WarningRedIcon} size={30} color={ADIColors.red1} />
                            </StyledWrapper>
                            <StyledWrapper>Operation failed. Please try again later.</StyledWrapper>
                        </Modal>
                    )}

                    {fileUploadCompleted && (
                        <Modal {...styles.removeAllModal} isOpen={fileUploadCompleted} handleClose={() => setFileUploadCompleted(false)}>
                            <StyledWrapper {...styles.loaderWapper}>
                                {/* <StyledWrapper {...styles.blueCircle}></StyledWrapper> */}
                                <StyledWrapper {...styles.uploadText}> Upload complete! </StyledWrapper>
                            </StyledWrapper>
                        </Modal>
                    )}
                    <StyledWrapper>
                        <Button variant="secondary" onClick={handleDownload} {...styles.buttonDownload}>
                            {translate("Download")}
                        </Button>
                        <Button
                            className={isValidFile ? "upload-button" : "disabled-button"}
                            {...styles.buttonUpload}
                            disabled={!isValidFile}
                            onClick={handleUpload}
                        >
                            {translate("Upload")}
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.errorsWrapper}>
                {mktRowErrors &&
                    mktRowErrors.map((error, index) =>
                        error !== undefined && index <= 10 ? (
                            <Typography as="p" {...styles.invalidFileExtension}>
                                {translate(error?.toString())}
                            </Typography>
                        ) : (
                            index === 11 && (
                                <Typography as="p" {...styles.invalidFileExtension}>
                                    {translate("There are more errors in the file…")}
                                </Typography>
                            )
                        ),
                    )}
            </StyledWrapper>
        </>
    );
};

export default connect(mapStateToProps)(MKTUploadZone);
